module.exports = __webpack_public_path__ + "img/3_199.692094b0.png";